import { get } from "lodash";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Header } from "semantic-ui-react";

import ErrorBoundary from "../../components/errorBoundaries/ErrorBoundary.jsx";
import SegmentMessage from "../../components/forms/messages/SegmentMessage.jsx";
import LoginFederatedForm from "../../components/sentry/LoginFederatedForm.jsx";
import LinkWithReset from "../../components/utils/LinkWithReset.jsx";

import { doLoginFederatedLink } from "../../state/reducers/authentication/federatedAuthenticationActions.js";
import { resetErrors } from "../../state/reducers/api/apiActions.js";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

import { AUTHENTICATION } from "../../state/reducers/authentication/authenticationConstants.js";
import { RESOURCE_KEYS, URL_ACTIONS } from "../../constants/entity.js";
import { ROUTES } from "../../constants/routing.js";

class LoginFederatedLink extends PureComponent {
  static propTypes = {
    doLoginFederatedLink: PropTypes.func.isRequired,
    resetErrors: PropTypes.func.isRequired,
    copy: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    const { section, action } = props.match.params;

    this.state = {
      showInviteMessage:
        section === RESOURCE_KEYS.INVITES && action === URL_ACTIONS.MANAGE,
      federatedError: null
    };
  }

  componentDidMount() {
    this.props.clearFederatedError();

    const params = new URLSearchParams(window.location.search);
    const error = params.get("error");

    if (error) {
      let message;

      switch (error) {
        case "FEDERATED_EXCHANGE_FAILED":
          const copyKey = "sentry.login_federated";

          message = this.props.copy(
            `${copyKey}.messages.error.exchange_failed`
          );
          break;

        default:
          message = error;
      }

      this.props.showFederatedError(message);

      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }

  componentWillUnmount() {
    this.props.clearFederatedError();
  }

  // -- HANDLERS -- //

  onSubmit = values => {
    this.props.resetErrors();
    this.props.doLoginFederatedLink(values.email);
  };

  // -- RENDER -- //

  renderMessage = copyKey => {
    const { copy } = this.props;

    return (
      <SegmentMessage
        title={copy(`${copyKey}.title`)}
        message={copy(`${copyKey}.message`)}
        className="sentry-form-message"
        info={true}
      />
    );
  };

  doManageCookies = () => {
    console.log("COOKIES!!!");
    Cookiebot.renew();
    console.log("COOKIES DONE!!!");
  };

  render() {
    const { copy } = this.props;
    const { federatedError } = this.props;
    const { showInviteMessage } = this.state;

    const copyKey = "sentry.login_federated";

    return (
      <div className="sentry-form">
        <Header as="h3" inverted textAlign="center">
          {copy(`${copyKey}.title`)}
        </Header>
        {showInviteMessage && this.renderMessage(`${copyKey}.messages.invite`)}
        <ErrorBoundary>
          {federatedError && (
            <SegmentMessage
              title={copy(`${copyKey}.messages.error.title`)}
              message={federatedError}
              negative={true}
            />
          )}

          <LoginFederatedForm onSubmit={this.onSubmit} />
          <footer>
            <LinkWithReset to="/">
              {copy(`${copyKey}.local_login_cta`)}
            </LinkWithReset>
          </footer>
        </ErrorBoundary>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state),
  federatedError: state.authentication.federatedError
});

const mapDispatchToProps = dispatch => ({
  doLoginFederatedLink: email => dispatch(doLoginFederatedLink(email)),
  resetErrors: () => dispatch(resetErrors()),
  showFederatedError: message =>
    dispatch({
      type: AUTHENTICATION.LOGIN_FEDERATED_LINK.FAILURE,
      payload: { message }
    }),
  clearFederatedError: () =>
    dispatch({
      type: AUTHENTICATION.LOGIN_FEDERATED_LINK.CLEAR_ERROR
    })
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginFederatedLink);
